import { render, staticRenderFns } from "./UserJobOrdersTable.vue?vue&type=template&id=50d13bc9&"
import script from "./UserJobOrdersTable.vue?vue&type=script&lang=js&"
export * from "./UserJobOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports